import { render, staticRenderFns } from "./noFooter.vue?vue&type=template&id=27f0b19e"
import script from "./noFooter.vue?vue&type=script&lang=js"
export * from "./noFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports